var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { Provider } from "react-redux";
import Helmet from "react-helmet";
import ReduxToastr from "react-redux-toastr";
import { ApolloProvider } from "react-apollo";
import { ACCOUNT } from "@irati-web/app/src/routeConfig";
import { store } from "@irati/store";
import TooltipNotification from "@irati/ui/src/TooltipNotification/TooltipNotification";
import CookieNotification from "@irati-web/platform/src/components/CookieNotification";
import NavigationBlocker from "@irati/utils/history/routing/Blocker";
import apolloClient from "@irati/utils/services/apollo";
import { LangLoader } from "@irati/utils/lang";
import LangProvider from "@irati/utils/lang/Provider";
var App = /** @class */ (function (_super) {
    __extends(App, _super);
    function App() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    App.prototype.render = function () {
        return (React.createElement(Provider, { store: store },
            React.createElement(ApolloProvider, { client: apolloClient },
                React.createElement(LangProvider, null,
                    React.createElement(LangLoader, { buckets: [ACCOUNT, "geolocation", "errors"] },
                        React.createElement("div", null,
                            React.createElement(Helmet, null,
                                React.createElement("title", null, "Perkbox")),
                            React.createElement(ReduxToastr, { preventDuplicates: true, transitionIn: "fadeIn", transitionOut: "fadeOut", position: "top-right" }),
                            React.createElement(TooltipNotification, null),
                            React.createElement(CookieNotification, null),
                            React.createElement(NavigationBlocker, null),
                            this.props.children))))));
    };
    return App;
}(PureComponent));
export default App;
